export default "__VITE_ASSET__BDHqJ074__"